import { render, staticRenderFns } from "./Tickets_Open.vue?vue&type=template&id=178091c0&scoped=true"
import script from "./Tickets_Open.vue?vue&type=script&lang=js"
export * from "./Tickets_Open.vue?vue&type=script&lang=js"
import style0 from "./Tickets_Open.vue?vue&type=style&index=0&id=178091c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178091c0",
  null
  
)

export default component.exports